import * as React from "react";
import { useTranslation } from "react-i18next";
import { Construction } from "lucide-react";
import { AdminShell } from "@/components/layout/admin-shell";
import { EmptyState } from "@/components/vroom/empty-state";
import { splitName } from "@/lib/split-name";
import {
  appSidebarSections,
  appBottomNavItems,
  type AppSection,
  type AppSidebarActiveKey,
} from "@/lib/app-sidebar";
import type { RoleKind } from "@/components/vroom/role-pill";

export interface PlaceholderPageProps {
  user: { name: string; role: RoleKind };
  section: AppSection;
  activeKey: AppSidebarActiveKey;
  breadcrumb: React.ReactNode;
  title: string;
  description?: string;
  icon?: React.ReactNode;
}

export function PlaceholderPage({
  user,
  section,
  activeKey,
  breadcrumb,
  title,
  description,
  icon,
}: PlaceholderPageProps) {
  const { t } = useTranslation();
  const { firstName, lastName } = splitName(user.name);
  return (
    <AdminShell
      user={{ firstName, lastName, role: user.role }}
      section={section}
      breadcrumb={breadcrumb}
      sidebarSections={appSidebarSections({ active: activeKey, role: user.role }, t)}
      bottomNavItems={appBottomNavItems({ section, active: activeKey, role: user.role }, t)}
    >
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <EmptyState
          variant="filtered"
          size="medium"
          icon={icon ?? <Construction size={48} />}
          title={title}
          description={description ?? t("common.placeholder-page.description")}
        />
      </div>
    </AdminShell>
  );
}
